import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export const Paywall = ({ company }) => {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-lg rounded-lg border border-amber-200 bg-amber-50 p-6 text-center" data-testid="paywall">
      <Lock className="mx-auto h-8 w-8 text-amber-700" />
      <h1 className="mt-3 text-xl font-semibold text-slate-900">{t("paywall.title")}</h1>
      <p className="mt-1 text-sm text-slate-700">
        {company?.trial_status === "trial_expired"
          ? "Din kostnadsfria provperiod på 60 dagar är slut. All din data ligger kvar – teckna abonnemang för att fortsätta arbeta."
          : company?.status === "past_due"
            ? t("paywall.pastDue")
            : t("paywall.hint")}
      </p>
      <Button asChild className="mt-4 h-11 bg-blue-600 text-white transition-colors duration-200 hover:bg-blue-700">
        <Link to="/abonnemang" data-testid="paywall-to-plans">{t("paywall.cta")}</Link>
      </Button>
      <p className="mt-3 text-xs text-slate-600">{t("paywall.dataSafe")}</p>
    </div>
  );
};

export default Paywall;
